import { render, staticRenderFns } from "./DroneTV.vue?vue&type=template&id=718506d9&scoped=true&"
import script from "./DroneTV.vue?vue&type=script&lang=ts&"
export * from "./DroneTV.vue?vue&type=script&lang=ts&"
import style0 from "./DroneTV.vue?vue&type=style&index=0&id=718506d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718506d9",
  null
  
)

export default component.exports